import * as React from 'react'
import { VariantProps, cva, cx } from 'class-variance-authority'

const textAreaVariants = cva(
  'focus-visible:ring-ring relative block w-full rounded-md border-border focus:ring-offset-2 focus-visible:outline-none text-sm px-2 disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500',
  {
    variants: {
      color: {
        default: 'focus:ring-primary-500 focus:border-border',
        tertiary: 'focus:ring-blue-800 focus:border-blue-800',
      },
    },
    defaultVariants: {
      color: 'default',
    },
  },
)

type TextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> &
  VariantProps<typeof textAreaVariants> & {
    className?: string
  }

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (props, ref) => {
    const { className, color, ...rest } = props
    return (
      <textarea
        ref={ref}
        className={cx(textAreaVariants({ color }), className)}
        {...rest}
      />
    )
  },
)

TextArea.displayName = 'TextArea'
